import React from "react";
import { resourcesFiles } from "../../../helpers/backend_helper";
import { dayjs } from "dayjs";

const fm = new Intl.NumberFormat("es-MX", {
  minimumFractionDigits: 2,
  maximumFractionDigits: 2,
});

const Columns = (addUpd, destroy, setModalFile, modalFile, report) => {
  const getFiles = async (id) => {
    let params = { params: { relation: "sale", id: id, field: "sale_id" } };
    const response = await resourcesFiles("get", params);
    setModalFile({ ...modalFile, show: true, id: id, items: response.files });
  };

  let columns = [
    {
      id: "concepto",
      name: "Concepto",
      minWidth:'150px',
      selector: (row) => row.concepto,
      sortable: true,
    },
    {
      id: "unit_id",
      name: "Unidad",
      minWidth:'100px',
      selector: (row) => `${row.unidad?.number}`,
      sortable: true,
      width: "15%",
    },
    {
      id: "operador_id",
      name: "Operador",
      minWidth:'200px',
      selector: (row) => row.operador?.full_name,
      sortable: false,
    },
    {
      id: "monto",
      name: "Monto",
      selector: (row) => fm.format(row.monto),
      sortable: true,
      minWidth:'120px',
    },
    {
      id: "fecha",
      name: "Fecha",
      selector: (row) => {
        return row.fecha.substring(0, 11);
      },
      sortable: true,
      minWidth:'120px',
    },
  ];
  if (!report) {
    columns.push({
      id: "actions",
      name: "Acciones",
      button: true,
      cell: (row) => (
        <>
          <div className="d-flex justify-content-between">
            <div className="p-2">
              <button
                className="btn btn-warning btn-sm"
                title="Editar venta"
                onClick={() => addUpd(row)}
              >
                <i className="fas fa-edit"></i>
              </button>
            </div>
            <div className="p-2">
              <button
                className="btn btn-danger btn-sm"
                title="Eliminar venta"
                onClick={() => destroy(row.id)}
              >
                <i className="fas fa-trash"></i>
              </button>
            </div>
          </div>
        </>
      ),
    });
  }
  return columns;
};

export default Columns;
